"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import HeaderBackground from "@/components/ui/header-background";
import { useTranslations } from "next-intl";
import { FC } from "react";
import S from "./index.module.scss";

interface IServiceHeader {
  video: string;
}

const ServiceHeader: FC<IServiceHeader> = ({ video }) => {
  const t = useTranslations();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  return (
    <>
      <HeaderBackground type="video" src={video} />
      <div className={S.headerWrapper}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h1 className={S.title}>{t("serviceCenter")}</h1>
      </div>
    </>
  );
};

export default ServiceHeader;
